import {styled} from "@mui/material/styles"
import {breakpoints} from "@next/ux-fabric"

export const InnerWrapper = styled("div")`
    display: flex;
    height: 100%;
    background-color: inherit;
    z-index: 2;
    margin-left: auto;
    margin-right: auto;
    width: 100%;
    align-items: center;
    max-width: ${breakpoints.values.xl}px;
    justify-content: space-between;

    padding-left: 1rem;

    @media (min-width: ${breakpoints.values.md}px) {
        padding: 0 1.563rem 0 2rem;
    }

    @media (min-width: ${breakpoints.values.lg}px) {
        padding: 0 1.563rem 0 2rem;
    }

    @media (min-width: ${breakpoints.values.xl}px) {
        padding: 0 0.75rem 0 2.6rem;
    }

    button {
        pointer-events: none;
    }
`

export const Wrapper = styled("div")`
    display: flex;
    align-items: center;
    background-color: ${({theme}) => theme.uxfabric.components.appBar.brandBar.default.backgroundColor};
    width: 100vw;

    height: 2.75rem;
    @media (min-width: ${breakpoints.values.md}px) {
        height: 3.75rem;
    }

    border-bottom: 1px solid;
    border-color: ${({theme}) => theme.uxfabric.components.appBar.brandBar.secure.borderColor};
`
